'use client';

import H1 from '@/components/typography/h1';
import H3 from '@/components/typography/h3';
import H4 from '@/components/typography/h4';
import P from '@/components/typography/p';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

const sections = [
    'privacyStatement',
    'aboutThisPolicy',
    'partners',
    'eventGuests',
    'influencers',
    'networkContacts',
    'newsletters',
    'websiteImprovement',
    'dataRights',
    'dataSharing',
    'dataSecurity',
    'contactInfo',
    'cookies',
    'whatAreCookies',
    'cookieUsage',
    'cookieTypes',
    'disableCookies',
];

export function PrivacyContent() {
    const { t } = useTranslation();

    return (
        <div className="list-bullet container mt-32 mb-10 flex max-w-[58.125rem] flex-col gap-5 px-5 lg:mt-44 lg:mb-28 lg:gap-10">
            <H1>{t('title')}</H1>
            {sections.map((key) => {
                const title = t(`${key}.title`);
                const content = t(`${key}.content`);

                return (
                    <section key={key} className="relative flex flex-col gap-3">
                        <H3>{title}</H3>
                        <P
                            dangerouslySetInnerHTML={{
                                __html: content,
                            }}
                        />

                        {key === 'cookieTypes' && (
                            <div className="flex flex-col gap-5">
                                {[
                                    'functionalCookies',
                                    'analyticalCookies',
                                    'googleAnalytics',
                                    'socialMediaCookies',
                                ].map((subKey) => (
                                    <div
                                        key={subKey}
                                        className="flex flex-col gap-2"
                                    >
                                        <H4>
                                            {t(
                                                `cookieTypes.subsections.${subKey}.title`,
                                            )}
                                        </H4>
                                        <P
                                            dangerouslySetInnerHTML={{
                                                __html: t(
                                                    `cookieTypes.subsections.${subKey}.content`,
                                                ),
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                        {key === 'contactInfo' && (
                            <Image
                                src="/images/stickers/cookie.png"
                                alt={t('contactInfo.title')}
                                className="absolute right-[-9rem] bottom-[-7rem] z-20 h-[300px] w-auto lg:right-[-22rem] lg:bottom-[-8rem] lg:h-[450px] xl:right-[-38rem] xl:bottom-[-10rem] xl:hidden xl:h-[550px]"
                                width={500}
                                height={300}
                            />
                        )}
                        {key === 'privacyStatement' && (
                            <Image
                                src="/images/stickers/cookie.png"
                                alt={t('contactInfo.title')}
                                className="absolute hidden xl:left-[calc(50vw+10rem)] xl:block"
                                width={500}
                                height={300}
                            />
                        )}
                        {key === 'partners' && (
                            <Image
                                src="/images/stickers/cookie.png"
                                alt={t('contactInfo.title')}
                                className="absolute hidden w-auto xl:right-[calc(50vw+12rem)] xl:block xl:h-[400px]"
                                width={500}
                                height={300}
                            />
                        )}
                    </section>
                );
            })}
        </div>
    );
}

PrivacyContent.displayName = 'PrivacyContent';
export default PrivacyContent;
